import React from "react";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import truck from "../../assets/img/Truck.png";
function DistributionSection() {
    return (
        <Container fluid>
            <Row className="distributer">
                <Col
                    md={6}
                    className="d-flex justify-content-center align-items-center distributer__leftSide"
                >
                    <img src={truck} width="100%" height="100%" alt="" />
                </Col>
                <Col
                    md={6}
                    className="d-flex justify-content-center align-items-center  p-4 text-white distributer__rightSide"
                    style={{
                        backgroundColor: "#25282a",
                    }}
                >
                    <div>
                        <h2 className="mb-3">
                            Is your Favorite Distributor Missing?
                        </h2>
                        <h3 className="mb-3">
                            Lets Get Them Added to the Location!
                        </h3>
                        <div className="text-center">
                            <Link
                                color="#25282a"
                                className="btn text-white border border-1"
                                size="lg"
                                to={`/new-distributer`}
                            >
                                Let Us Know
                            </Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default DistributionSection;
